import type { FC, ReactElement, ReactNode } from "react"
import { Fragment } from "react"

import { createPortal } from "react-dom"

type _TProps = {
    withPortal?: boolean
    children?: ReactNode
}

const MODAL_PORTAL_ID: string = "modal-portal"

const ModalPortal: FC<_TProps> = ({ withPortal = false, children }: _TProps): ReactElement => {
    const domElement: HTMLElement = document.getElementById(MODAL_PORTAL_ID)

    return withPortal ? createPortal(children, domElement) : <Fragment>{children}</Fragment>
}

ModalPortal.displayName = "ModalPortal"

export default ModalPortal
